<mat-toolbar class="subtitulo">Entrega de uniforme</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="70%" fxFlexOffset="20px">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Selecione uma atividade</mat-label>
                    <mat-select fxFlexOffset="20px" [(ngModel)]="filtroBusca.atividade" name="atividade">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of atividades" [value]="d">
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <button mat-raised-button fxFlex="10%" (click)="consultar()" *ngIf="filtroBusca.atividade && filtroBusca.atividade.id">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="10%" (click)="limpar()">
                    LIMPAR
                </button>

            </div>

            <div *ngIf="filtroBusca.atividade && filtroBusca.atividade.id">
                <dados-atividade [atividade]=filtroBusca.atividade></dados-atividade>
            </div>

            <div *ngIf="mostrarTabela" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Informe um valor para filtrar</mat-label>
                    <input fxFlexOffset="20px" matInput (keyup)="applyFilter($event.target.value)" >
                </mat-form-field>
            </div>

            <table [fxHide]="!mostrarTabela"
                   matSort
                   mat-table
                   [dataSource]="dataSource"
                   style="margin-top: 10px">

                <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef> Aluno </th>
                    <td mat-cell *matCellDef="let element;  let i = index" style="width: 300px">
                        <div *ngIf="element.id; else comboNomeTemplate">
                            {{element.atividadesAluno.aluno.pessoaFisica.nome}}
                        </div>
                        <ng-template #comboNomeTemplate>
                            <mat-form-field style="width: 95%">
                                <mat-select [(ngModel)]="element.atividadesAluno.id"
                                            (selectionChange)="getAtividadeAluno(element, $event.value)"
                                            [ngModelOptions]="{standalone: true}"                                            
                                            required>
                                    <mat-option></mat-option>
                                    <mat-option *ngFor="let i of atividadesAlunos" [value]="i.id" 
                                                ngDefaultControl>
                                        {{i.aluno.pessoaFisica.nome}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="nomeUniforme">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Uniforme </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div *ngIf="element.id; else comboUniformeTemplate">
                            {{element.nomeUniforme}}
                        </div>
                        <ng-template #comboUniformeTemplate>
                            <mat-form-field>
                                <input matInput
                                       [ngModelOptions]="{standalone: true}"
                                       maxlength="45"
                                       [disabled]="element.disabilitado"
                                       [(ngModel)]="element.nomeUniforme">
                            </mat-form-field>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="dataUniformeEntregue">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Data de entrega </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                            <div *ngIf="element.id; else comboDataEntregaTemplate">
                                {{element.dataUniformeEntregue | dataSimples}}
                            </div>
                            <ng-template #comboDataEntregaTemplate>
                                <mat-form-field>
                                    <input matInput
                                           [disabled]="element.disabilitado"
                                           name="dataUniformeEntregue"
                                           [max]="maxDate"
                                           [min]="minDate"
                                           [matDatepicker]="datareferencia"
                                           [(ngModel)]="element.dataUniformeEntregue">
                                    <mat-datepicker-toggle matSuffix [for]="datareferencia"></mat-datepicker-toggle>
                                    <mat-datepicker #datareferencia></mat-datepicker>
                                </mat-form-field>
                            </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="qtdUniformeEntregue">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantidade</th>
                    <td mat-cell *matCellDef="let element;  let i = index" style="width: 50px">
                        <mat-form-field style="width: 50%">
                            <input matInput
                                   [disabled]="element.disabilitado"
                                   [ngModelOptions]="{standalone: true}"
                                   maxlength="10"
                                   [(ngModel)]="element.qtdUniformeEntregue"
                                   pattern="[0-9]+$"
                                   style="text-align: center">
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="datamatricula">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Data início matrícula </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        {{element.atividadesAluno.dataInicioAtividade | dataSimples}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element;">
                        <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="perfilAcesso.altera" mat-button (click)="editar(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </form>

        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[10, 20, 40, 80]" showFirstLastButtons></mat-paginator>
        </div>

        <div [hidden]="mostrarTabela">
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </div>

        <div fxLayout="row" *ngIf="perfilAcesso.insere && filtroBusca.atividade && filtroBusca.atividade.id"
             fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova entrega de uniforme" mat-fab color="primary" (click)="novo()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- BOTOES -->
    <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                   fxFlexFill *ngIf="mostrarTabela">

        <button *ngIf="perfilAcesso.altera" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formulario.invalid" (click)="atualizar()">
            Atualizar
        </button>

        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
            Cancelar
        </button>

    </div>

</div>
